export default () => window.documentViewer.getWatermark();
